<mat-card-subtitle style="margin-top: 16px;">
  {{containerDesc}}
</mat-card-subtitle>

<form class="dynamic-form" [formGroup]="form" style="width: 100%">
  <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

    <mat-form-field fxFlex="40" width="100%">
      <mat-label>RCS Card Number</mat-label>
      <input matInput style="text-align: right;" type="text" minlength="19" maxlength="19" formControlName="cardNumber"
        autocomplete="new-password">
    </mat-form-field>

    <mat-form-field fxFlex="20" width="100%">
      <mat-label>Amount Tendered</mat-label>
      <input matInput style="text-align: right;" type="number" formControlName="amountTendered"
        autocomplete="new-password" (keyup)="amountTenderedChanged()" (focusout)="amountTenderedFocusOut()">
    </mat-form-field>

    <mat-form-field fxFlex="20" width="100%">
      <mat-label>Minus Outstanding</mat-label>
      <input matInput style="text-align: right;" type="number" formControlName="amountOutstanding">
    </mat-form-field>

    <mat-form-field fxFlex="20" width="100%">
      <mat-label>Equals Unpaid</mat-label>
      <input matInput style="text-align: right;" type="number" formControlName="amountDifference">
    </mat-form-field>

    <!--
    <mat-form-field fxFlex="50" width="100%">
      <mat-label>Last 2 Card Numbers</mat-label>
      <input matInput style="text-align: right;" type="text" minlength="2" maxlength="2" formControlName="lastTwoCardNumbers" autocomplete="new-password">
    </mat-form-field> -->

    <!-- <mat-form-field fxFlex="100" width="100%">
      <mat-label>Last 4 Card Numbers</mat-label>
      <input matInput style="text-align: right;" type="text" minlength="4" maxlength="4" formControlName="lastFourCardNumbers" autocomplete="new-password">
    </mat-form-field> -->

  </div>
</form>
